import React, { useState } from "react";
import "./Login.css";
import Header from "./Header";
import Footer from "./Footer";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

const handleLogin = async (e) => {
  e.preventDefault();

  if (!email || !password) {
    alert("Please enter email and password");
    return;
  }

  try {
    setLoading(true);

    const response = await fetch(
      "https://aethearia.store/superadmin/api/login",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
        }),
      }
    );

    const data = await response.json(); 

    console.log("Response:", data);

    if (data.status) {
  // alert(data.message || "Login successful");

  localStorage.setItem("user", JSON.stringify(data.data));

  navigate("/"); // redirect to home page
}else {
      alert(data.message || "Invalid credentials");
    }
  } catch (err) {
    console.error("Login Error:", err);
    alert("Something went wrong");
  } finally {
    setLoading(false);
  }
};
  return (
    <>
      <Header />

      <div className="login-page">
        <div className="overlay1">
          <div className="login-box">
            <h2>Customer Login</h2>

            <form onSubmit={handleLogin}>
              <div className="input-group">
                <label>Email Id</label>
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="input-group">
                <label>Password</label>

                <div className="password-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                    <span
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)}
                    >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                </div>
              </div>

              <button type="submit" className="login-btn" disabled={loading}>
                {loading ? "LOGGING IN..." : "LOGIN"}
              </button>

              <p className="forgot-password">
                <Link to="/forgot-password" className="forgot-password">
                  Lost your password?
                </Link>
              </p>

              {/* <button type="button" className="google-btn">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/281/281764.png"
                  alt="google"
                />
                Login With Google
              </button> */}

             <p className="register-text">
                Don’t have an account?{" "}

                <Link to="/register" className="register-link">
                    Create a new account
                </Link>
                </p>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}